// extracted by mini-css-extract-plugin
module.exports = {"table":"reportContableDetail_table__1kfln","hidden":"reportContableDetail_hidden__2_UU6"};